<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  created() {
    document.title = "报考系统";
    sessionStorage.getItem("appstore") &&
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem("appstore"))
        )
      );
    //在页面刷新时将vuex里的信息保存到localStorage里
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("appstore", JSON.stringify(this.$store.state));
    });
  },
};
</script>

<style>
body,
h1,
h2,
h3,
h4,
h5,
h6,
p,
dl,
dt,
dd,
ul,
ol,
li,
form,
button,
input,
textarea,
th,
td {
  font-weight: normal;
  margin: 0;
  padding: 0;
}

body,
button,
input,
select,
textarea,
h1,
h2,
h3,
h4,
h5,
h6,
i {
  font: normal 12px/1.5 "Helvetica Neue", "Microsoft YaHei", Helvetica, STHeiTi,
    sans-serif;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
}

ul,
ol,
li {
  list-style: none;
}

a {
  text-decoration: none;
  color: #333;
}

a:hover {
  text-decoration: none;
}

img {
  vertical-align: top;
  border: 0;
}
body {
  -webkit-tap-highlight-color: transparent;
  cursor: pointer;
  -webkit-overflow-scrolling: touch;
}
button,
input,
textarea {
  font-size: 100%;
  vertical-align: middle;
  outline: none;
  -moz-appearance: none;
  appearance: none;
  appearance: none !important;
  -webkit-appearance: none !important;
  border-radius: 0;
}
input[type="checkbox"],
input[type="radio"] {
  display: none;
  -webkit-appearance: none;
}
table {
  border-spacing: 0;
  border-collapse: collapse;
}

div,
a {
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
}
.main {
  width: 100%;
  max-width: 750px;
  margin: 0 auto;
  padding: 0;
  position: relative;
}
@media screen and (min-width: 768px) {
  .main {
    width: 375px;
  }
}
.left {
  float: left;
}
.right {
  float: right;
}

.clearfloat {
  clear: both;
  zoom: 1;
}
.clearfloat:after {
  content: ".";
  height: 0;
  visibility: hidden;
  display: block;
  clear: both;
}

.content {
  padding-bottom: 1.2rem;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
/* .bg0 {
  background-image: url(assets/f_icon04.png);
}
.bg1 {
  background-image: url(assets/f_icon14.png);
}
.bg2 {
  background-image: url(assets/f_icon12.png);
}
.bg3 {
  background-image: url(assets/f_icon10.png);
}
.bg4 {
  background-image: url(assets/f_icon13.png);
}
.bg5 {
  background-image: url(assets/f_icon03.png);
}
.bg6 {
  background-image: url(assets/f_icon01.png);
}
.bg7 {
  background-image: url(assets/f_icon05.png);
}
.bg8 {
  background-image: url(assets/f_icon18.png);
}
.bg9 {
  background-image: url(assets/f_icon11.png);
}
.bg10 {
  background-image: url(assets/f_icon08.png);
}
.bg11 {
  background-image: url(assets/f_icon09.png);
}
.bg12 {
  background-image: url(assets/f_icon16.png);
}
.bg13 {
  background-image: url(assets/f_icon02.png);
}
.bg18 {
  background-image: url(assets/icon18.png);
} */
</style>
